import { useEffect, useMemo, useRef, useState } from "react";
import "./phoneInput.css";

const PhoneNumberInput = ({
  value,
  onChange,
  countryCode,
  countries = [],
}) => {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");

  const wrapperRef = useRef(null);

  const selectedCountry = useMemo(() => {
    return countries.find((c) => c.code === countryCode) || countries[0];
  }, [countryCode, countries]);

  const filteredCountries = useMemo(() => {
    return countries.filter((c) =>
      c.label.toLowerCase().includes(search.toLowerCase())
    );
  }, [search, countries]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelectCountry = (country) => {
    setOpen(false);
    setSearch("");

    onChange({
      phone: value.phone,
      countryCode: country.code,
      dial: country.dial,
    });
  };

  const handlePhoneChange = (e) => {
    const raw = e.target.value.replace(/\D/g, "");

    onChange({
      phone: raw,
      countryCode,
      dial: selectedCountry?.dial,
    });
  };

  return (
    <div className="phN-wrapper" ref={wrapperRef}>
      
      <div className="phN-container">

        <div className="phN-countryBox">
          <div
            className="phN-selectedCountry"
            onClick={() => setOpen(!open)}
          >
            <img
              src={selectedCountry?.flag}
              alt=""
              className="phN-flag"
            />
            <span>+{selectedCountry?.dial}</span>
          </div>

          {open && (
            <div className="phN-dropdown">

              <input
                className="phN-search"
                placeholder="Rechercher un ppays..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />

              <div className="phN-list">
                {filteredCountries.map((c) => (
                  <div
                    key={c.code}
                    className="phN-item"
                    onClick={() => handleSelectCountry(c)}
                  >
                    <img src={c.flag} className="phN-flag" />
                    <span>
                      {c.label} +{c.dial}
                    </span>
                  </div>
                ))}
              </div>

            </div>
          )}
        </div>

        <input
          className="phN-input"
          placeholder="Numéro de téléphone"
          value={value.phone || ""}
          onChange={handlePhoneChange}
        />
      </div>
    </div>
  );
};

export default PhoneNumberInput;